<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    :class="{ spinning }"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.57496 3.31192C3.99141 2.94917 4.6538 2.96325 5.05445 3.34337L9.62066 7.67563C10.0213 8.05575 10.0085 8.65797 9.59206 9.02073C9.17562 9.38349 8.51323 9.36941 8.11258 8.98928L3.54637 4.65703C3.14572 4.2769 3.15852 3.67468 3.57496 3.31192Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.57509 20.6881C3.99153 21.0508 4.65392 21.0368 5.05457 20.6566L9.62078 16.3244C10.0214 15.9443 10.0086 15.342 9.59219 14.9793C9.17574 14.6165 8.51335 14.6306 8.1127 15.0107L3.54649 19.343C3.14584 19.7231 3.15864 20.3253 3.57509 20.6881Z"
      fill="currentColor"
    />
    <path
      opacity="0.8"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M21.2919 20.6881C20.8754 21.0508 20.213 21.0368 19.8124 20.6566L15.2462 16.3244C14.8455 15.9443 14.8583 15.342 15.2748 14.9793C15.6912 14.6165 16.3536 14.6306 16.7542 15.0107L21.3205 19.343C21.7211 19.7231 21.7083 20.3253 21.2919 20.6881Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.5504 0C13.1027 0 13.5504 0.447715 13.5504 1V7C13.5504 7.55228 13.1027 8 12.5504 8C11.9981 8 11.5504 7.55228 11.5504 7V1C11.5504 0.447715 11.9981 0 12.5504 0Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.5504 24C13.1027 24 13.5504 23.5523 13.5504 23L13.5504 17C13.5504 16.4477 13.1027 16 12.5504 16C11.9981 16 11.5504 16.4477 11.5504 17L11.5504 23C11.5504 23.5523 11.9981 24 12.5504 24Z"
      fill="currentColor"
    />
    <path
      opacity="0.6"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M24.0004 12C24.0004 12.5523 23.5527 13 23.0004 13H18.6004C18.0481 13 17.6004 12.5523 17.6004 12C17.6004 11.4477 18.0481 11 18.6004 11H23.0004C23.5527 11 24.0004 11.4477 24.0004 12Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.6001 12C8.6001 12.5523 8.15238 13 7.6001 13H1.0001C0.447811 13 9.63211e-05 12.5523 9.63211e-05 12C9.63211e-05 11.4477 0.447811 11 1.0001 11H7.6001C8.15238 11 8.6001 11.4477 8.6001 12Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  props: {
    spinning: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style>
.spinning {
  animation: spin 4s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
